/* THE REEL POPUP (decision 114, 2026-10-02). The look and its reasoning are in reel-pop.css.
   sections/reel-pop.liquid writes the list of reels as JSON and loads this file; this file
   builds the markup, mounts it on <body> and runs the behaviour:

     arrives      once the page is scrolled past 0.3 of a screen, and leaves again above it, so it
                  never sits over the hero's buttons
     steps aside  while the buy section, the reel section or the footer is on screen, and while
                  anything marked data-reelpop-clear (a buy button) is under its corner
     dismiss      the round close control hides it for the visit (sessionStorage)
     the viewer   a tap on a card opens that reel, with sound, story-style

   Nothing here reads or writes the theme's other scripts. */
(function () {
  'use strict';
  if (window.MOGPOP) return;

  var CFG = null;
  try { CFG = JSON.parse(document.querySelector('script[data-reelpop]').textContent); } catch (e) {}
  if (!CFG || !CFG.reels || !CFG.reels.length) return;

  /* the reels, in the section's block order. Reel 1 is the front card. The fan is drawn for three
     cards, so it holds the first three; the viewer plays all of them in order. */
  var REELS = CFG.reels.slice(0, 6), N = REELS.length, CARDS = Math.min(N, 3);
  /* The words on the widget. The hashtag and the button are the reel section's own. The line
     above the cards is Ashot's (2026-10-02: "above the vids have a SEE HOW OTHERS in smaller red
     letters"), so the piece reads See how others #MOG from its top to its foot. Not settings:
     each sticker's box is cut to its own word (see sticker() below), so a new word is a new cut. */
  var HASH = '#MOG';
  var LEAD = 'SEE HOW OTHERS';
  var CTA = CFG.cta || 'Experience MOG MINTS';
  var SHOP = CFG.shop || '/';
  var KEY = 'reelpop:hidden';

  var ARRIVE = 0.30, LEAVE = 0.22;      /* the trigger in screens of scroll, with a gap so it cannot flap on the line */
  var ASIDE = 0.15, BACK = 0.08;        /* the share of the screen a section must cover to send it away, and to let it back */
  var WHOLE = ['buy', 'reel', 'site-foot'];     /* the sections it steps aside for whole */
  var ZONE_W = 280, ZONE_H = 380;       /* the popup's corner of the screen at desktop scale, with a little air round it */

  var ICON = {
    play: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5.2v13.6L19.2 12z"/></svg>',
    x: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M14.5 5.5L8 12l6.5 6.5"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9.5 5.5L16 12l-6.5 6.5"/></svg>',
    /* the reel section's own speaker glyph (sections/index-reel.liquid): waves when on, a cross when off */
    snd: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 9.5v5h3.2l4.8 3.8V5.7L7.2 9.5H4z"/>' +
      '<path class="reelview__wave" d="M15.5 9.3a3.8 3.8 0 0 1 0 5.4M18 6.8a7.3 7.3 0 0 1 0 10.4"/>' +
      '<path class="reelview__mute" d="M16 10l4 4M20 10l-4 4"/></svg>'
  };

  var mqStill = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function still() { return mqStill.matches; }
  var touch = !!(window.matchMedia && matchMedia('(hover: none)').matches);

  var root = null, rig = null, hand = null, slots = [], cards = [];
  var st = { ready: false, arrived: false, aside: false, hidden: false, shown: false };
  try { st.hidden = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
  var landT = 0;

  function h(tag, cls, attrs, html) {
    var e = document.createElement(tag), k;
    if (cls) e.className = cls;
    if (attrs) for (k in attrs) e.setAttribute(k, attrs[k]);
    if (html) e.innerHTML = html;
    return e;
  }

  /* ---------- the markup ---------- */

  function card(i) {
    var b = h('button', 'reelpop__card', { type: 'button', 'data-i': i, 'aria-label': 'Play reel ' + (i + 1) + ' of ' + N });
    /* the card is 104px wide at most, so it takes the 240px rendition, not the 720px poster */
    b.appendChild(h('img', '', { src: REELS[i].thumb || REELS[i].poster, alt: '', width: '240', height: '427', decoding: 'async', draggable: 'false' }));
    if (i === 0) b.appendChild(h('span', 'reelpop__play', { 'aria-hidden': 'true' }, ICON.play));
    b.addEventListener('click', function () { openView(i, b); });
    cards.push(b);
    return b;
  }

  /* A word cut as a sticker round its own outline: the word three times over (hairline, white
     plate, letters) in a box cut to the plate. See reel-pop.css for the numbers. `box` is the SVG
     view box, x and y the middle of the word and its baseline in the same units.
     THE TAP AREA IS A SHAPE OF ITS OWN. SVG hit-tests text by its character cells, not its paint,
     so the letters would take taps well past the plate, over the cards beside it. The texts take
     none and a transparent rounded box the size of the plate takes them. */
  function sticker(cls, text, box, x, y) {
    var t = '<text x="' + x + '" y="' + y + '">' + text + '</text>';
    return '<svg class="reelpop__word ' + cls + '" viewBox="' + box.join(' ') + '" aria-hidden="true" focusable="false">' +
      t.replace('<text', '<text class="w-hair"') + t.replace('<text', '<text class="w-cut"') + t.replace('<text', '<text class="w-ink"') +
      '<rect class="w-hit" x="' + (box[0] + 3) + '" y="' + (box[1] + 3) + '" width="' + (box[2] - 6) + '" height="' + (box[3] - 6) + '" rx="' + Math.round(box[3] * 0.29) + '"/></svg>';
  }

  function build() {
    root = h('div', 'reelpop' + (touch ? ' is-touch' : ' is-hover'), { role: 'group', 'aria-label': 'Reels' });
    rig = h('div', 'reelpop__rig');
    hand = h('div', 'reelpop__hand');
    /* a slot per card, in reel order, holding the card */
    for (var i = 0; i < CARDS; i++) {
      var s = h('div', 'reelpop__slot');
      s.style.setProperty('--i', i);
      s.appendChild(card(i));
      hand.appendChild(s);
      slots.push(s);
    }
    /* the two stickers: the line above the cards and the hashtag across their feet. Neither is a
       control (the three cards are, and they carry the labels), but a tap on a sticker that does
       nothing reads as broken, so each opens the front reel. */
    hand.insertAdjacentHTML('beforeend',
      sticker('reelpop__word--lead', LEAD, [0, 0, 679, 152], 339.5, 113) +
      sticker('reelpop__word--tag', HASH, [6, 16, 212, 118], 112, 104));
    [].forEach.call(hand.querySelectorAll('.reelpop__word'), function (w) {
      w.addEventListener('click', function () { openView(0, cards[0]); });
    });
    rig.appendChild(hand);
    var x = h('button', 'reelpop__x', { type: 'button', 'aria-label': 'Hide reels' }, ICON.x);
    x.addEventListener('click', dismiss);
    rig.appendChild(x);
    root.appendChild(rig);
    document.body.appendChild(root);
    /* NO requestAnimationFrame HERE (the cart drawer's lesson): reading a size forces the layout
       of the out state, so adding is-in afterwards has something to animate from. */
    void root.offsetWidth;
  }

  /* ---------- arriving, stepping aside, leaving ---------- */

  function sync() {
    if (!root) return;
    var want = st.ready && st.arrived && !st.aside && !st.hidden;
    if (want === st.shown) return;
    st.shown = want;
    clearTimeout(landT);
    if (want) {
      root.classList.add('is-in');
      /* is-landed marks the entrance as spent: from here the fan answers the pointer */
      landT = setTimeout(function () { if (root) root.classList.add('is-landed'); }, still() ? 0 : 950);
    } else {
      root.classList.remove('is-in');
      root.classList.remove('is-landed');
      swayStop();
    }
  }

  function dismiss() {
    st.hidden = true;
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    sync();
  }

  /* HOW MUCH OF THE SCREEN A SECTION REALLY SHOWS. Its rect alone lies on a desktop: the hand-off
     (assets/handoff.js) freezes #buy with position sticky on its section wrapper, and the wrapper
     stays stuck UNDER every later section for the rest of the page. Measured at 1440 by 900:
     #buy reads top -1593, bottom 900 from the moment it freezes to the footer. An
     IntersectionObserver on it would therefore keep the popup away for good. What the visitor
     sees of a frozen section is only the part above the next section's top edge, so that is
     where the rect is cut. For a section that is not frozen the cut changes nothing. */
  function seen(el, vh) {
    var r = el.getBoundingClientRect();
    var top = Math.max(r.top, 0), bot = Math.min(r.bottom, vh);
    var wrap = el.closest('.shopify-section') || el, next = wrap.nextElementSibling;
    if (next && next !== root && next.getClientRects().length) bot = Math.min(bot, next.getBoundingClientRect().top);
    return Math.max(0, bot - top);
  }

  /* IS A MARKED CONTROL UNDER THE POPUP'S CORNER. A buy button outside the sections above (the
     closing section's, the science page's) carries data-reelpop-clear, and the popup leaves while
     any part of one is inside the corner it stands in. Measured on a 390px phone before this
     rule: the hand covered the right end of the closing section's red button. Once away it comes
     back only when the control is clear by a further 24px, so it cannot flap on the line. */
  function under(el, vw, vh, pad) {
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    var k = vw <= 760 ? 0.66 : 1;
    return r.right > vw - ZONE_W * k - pad && r.bottom > vh - ZONE_H * k - pad && r.top < vh && r.left < vw;
  }

  var whole = [], clear = [], near = true, ticking = false;

  function measure() {
    ticking = false;
    var vh = window.innerHeight || 1, vw = window.innerWidth || 1, y = window.scrollY || window.pageYOffset || 0, cov = 0, hit = false, i;
    if (!st.arrived && y > ARRIVE * vh) st.arrived = true;
    else if (st.arrived && y < LEAVE * vh) st.arrived = false;
    if (near) {
      for (i = 0; i < whole.length; i++) cov += seen(whole[i], vh);
      for (i = 0; i < clear.length && !hit; i++) hit = under(clear[i], vw, vh, st.aside ? 24 : 0);
    }
    cov = cov / vh;
    st.aside = hit || (st.aside ? cov > BACK : cov >= ASIDE);
    sync();
  }
  function schedule() { if (!ticking) { ticking = true; requestAnimationFrame(measure); } }

  function onScroll() {
    schedule();
    swayKick();
  }

  /* The observer does not decide anything (see seen() for why it cannot). It only says whether
     anything the popup steps aside for is near the screen at all, so the rest of the page costs
     no measuring on scroll. */
  function observe() {
    WHOLE.forEach(function (id) { var el = document.getElementById(id); if (el) whole.push(el); });
    clear = [].slice.call(document.querySelectorAll('[data-reelpop-clear]'));
    var all = whole.concat(clear);
    if (!all.length || !('IntersectionObserver' in window)) return;
    near = false;
    var on = [];
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var i = on.indexOf(e.target);
        if (e.isIntersecting && i < 0) on.push(e.target);
        else if (!e.isIntersecting && i > -1) on.splice(i, 1);
      });
      near = on.length > 0;
      schedule();
    });
    all.forEach(function (el) { io.observe(el); });
  }

  /* ---------- the hand sways with the scroll ---------- */

  /* Scroll speed pushes each card a few degrees off its place and a spring brings it back, like
     cards in a moving hand. The back card swings furthest and loosest, the front card least, so
     the fan breathes instead of turning as one board. Scrolling down closes the fan a little
     (the tips lag behind the hand), scrolling up opens it. The loop runs only from the first
     scroll event until every card has settled. */
  var SWAY_GAIN = 2.1, SWAY_CAP = 4;                       /* degrees per px/ms of scroll, and the most it may ask for */
  var SWAY_REACH = [0.4, 0.72, 1], SWAY_K = [210, 170, 140], SWAY_C = [15, 13.5, 12];
  var SW = { a: [0, 0, 0], w: [0, 0, 0], vel: 0, y: 0, t: 0, raf: 0, prev: 0 };

  function swayKick() {
    if (!st.shown || still() || !slots.length) return;
    var now = performance.now(), y = window.scrollY || 0, dt = now - SW.t;
    if (dt >= 140) SW.vel = 0;                             /* a new scroll, not a continuing one */
    else if (dt > 4) SW.vel += ((y - SW.y) / dt - SW.vel) * 0.4;
    if (dt > 4) { SW.y = y; SW.t = now; }
    if (!SW.raf) { SW.prev = 0; SW.raf = requestAnimationFrame(swayStep); }
  }
  function swayStep(now) {
    var dt = SW.prev ? Math.min(34, now - SW.prev) / 1000 : 1 / 60, i, acc, live;
    SW.prev = now;
    if (now - SW.t > 70) SW.vel *= 0.72;                   /* the scroll stopped feeding it: let the push die */
    var push = Math.max(-SWAY_CAP, Math.min(SWAY_CAP, SW.vel * SWAY_GAIN));
    live = Math.abs(push) > 0.02;
    for (i = 0; i < slots.length; i++) {
      acc = SWAY_K[i] * (push * SWAY_REACH[i] - SW.a[i]) - SWAY_C[i] * SW.w[i];
      SW.w[i] += acc * dt;
      SW.a[i] += SW.w[i] * dt;
      if (Math.abs(SW.a[i]) > 0.01 || Math.abs(SW.w[i]) > 0.06) live = true;
      slots[i].style.rotate = SW.a[i].toFixed(3) + 'deg';
    }
    if (live && st.shown) SW.raf = requestAnimationFrame(swayStep);
    else swayStop();
  }
  function swayStop() {
    if (SW.raf) cancelAnimationFrame(SW.raf);
    SW.raf = 0; SW.prev = 0; SW.vel = 0;
    for (var i = 0; i < slots.length; i++) { SW.a[i] = 0; SW.w[i] = 0; slots[i].style.rotate = ''; }
  }

  /* ---------- the viewer ---------- */

  var view = null, vid = null, fills = [], sndBtn = null, closeBtn = null;
  var viewOn = false, cur = 0, opener = null, barRaf = 0, hideT = 0;

  function button(cls, label, icon, fn) {
    var b = h('button', cls, { type: 'button', 'aria-label': label }, icon);
    b.addEventListener('click', fn);
    return b;
  }

  function buildView() {
    view = h('div', 'reelview' + (touch ? ' is-touch' : ''), { role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Reels', hidden: '' });
    var scrim = h('div', 'reelview__scrim');
    scrim.addEventListener('click', closeView);
    var frame = h('div', 'reelview__frame');
    var media = h('div', 'reelview__media');
    /* preload none and no src: nothing is fetched until a card is tapped */
    vid = h('video', '', { playsinline: '', 'webkit-playsinline': '', preload: 'none' });
    media.appendChild(vid);
    var bars = h('div', 'reelview__bars', { 'aria-hidden': 'true' });
    for (var i = 0; i < N; i++) { var seg = h('i'), f = h('b'); seg.appendChild(f); bars.appendChild(seg); fills.push(f); }
    closeBtn = button('reelview__btn reelview__x', 'Close', ICON.x, closeView);
    sndBtn = button('reelview__btn reelview__snd', 'Turn sound off', ICON.snd, function () {
      vid.muted = !vid.muted;
      if (vid.paused) play();
      label();
    });
    var cta = h('a', 'reelview__cta', { href: SHOP }, CTA);
    /* On the product page the buy card is the top of this same page, so the button closes the
       viewer and goes up to it, the way the closing section's button does there
       (index-close.liquid): to the top of the page, not to the card's rect, which reports where
       the frozen section is stuck and stopped the first build 1,800px short. */
    cta.addEventListener('click', function (e) {
      if (!document.body.classList.contains('template-product') || !document.getElementById('buy')) return;
      e.preventDefault();
      closeView();
      window.scrollTo({ top: 0, left: 0, behavior: still() ? 'auto' : 'smooth' });
      /* the product form's Add to cart by its name, as index-close.liquid does (2026-10-14: .ofr__cta first matched the
         reviews' hidden Post review button on the new product card); .ofr__cta is the fallback */
      var add = document.querySelector('#mog-buy [name="add"]') || document.querySelector('.ofr__cta');
      if (add && add.focus) add.focus({ preventScroll: true });
    });
    frame.appendChild(media);
    frame.appendChild(bars);
    frame.appendChild(closeBtn);
    frame.appendChild(button('reelview__btn reelview__prev', 'Previous reel', ICON.prev, function () { step(-1); }));
    frame.appendChild(button('reelview__btn reelview__next', 'Next reel', ICON.next, function () { step(1); }));
    frame.appendChild(h('p', 'reelview__hash', { 'aria-hidden': 'true' }, HASH));
    frame.appendChild(sndBtn);
    frame.appendChild(cta);
    view.appendChild(scrim);
    view.appendChild(frame);
    document.body.appendChild(view);

    /* the next reel follows by itself, and the last one closes the viewer, the way a story ends */
    vid.addEventListener('ended', function () { if (viewOn) step(1); });
    vid.addEventListener('volumechange', label);
  }

  function label() {
    var on = !vid.muted;
    sndBtn.classList.toggle('is-on', on);
    sndBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    sndBtn.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
  }

  function play() {
    var p = vid.play();
    if (p && p.then) p.then(null, function (err) {
      /* a browser that will not start with sound (no gesture behind the call) gets it muted,
         and the button says so */
      if (err && err.name === 'NotAllowedError' && !vid.muted) {
        vid.muted = true; label();
        var q = vid.play(); if (q && q.then) q.then(null, function () {});
      }
    });
  }

  /* nothing here seeks: every change of reel is a fresh src from the start */
  function go(i) {
    cur = i;
    for (var j = 0; j < N; j++) fills[j].style.transform = 'scaleX(' + (j < i ? 1 : 0) + ')';
    vid.setAttribute('poster', REELS[i].poster);
    vid.setAttribute('aria-label', 'Reel ' + (i + 1) + ' of ' + N);
    vid.src = REELS[i].file;
    play();
  }
  function step(d) {
    var n = cur + d;
    if (n >= N) { closeView(); return; }
    go(n < 0 ? 0 : n);                       /* back on the first reel starts it again */
  }
  function bar() {
    if (!viewOn) return;
    var d = vid.duration, p = (d > 0 && isFinite(d)) ? vid.currentTime / d : 0;
    fills[cur].style.transform = 'scaleX(' + Math.max(0, Math.min(1, p)).toFixed(4) + ')';
    barRaf = requestAnimationFrame(bar);
  }

  function openView(i, from) {
    i = Math.max(0, Math.min(N - 1, i | 0));
    if (!view) buildView();
    clearTimeout(hideT);
    if (!viewOn) opener = from || document.activeElement;
    view.hidden = false;
    document.documentElement.classList.add('reelpop-lock');
    void view.offsetHeight;                  /* forces the layout the fade starts from; no rAF */
    view.classList.add('is-on');
    viewOn = true;
    vid.muted = false;                      /* sound on: the tap that opened it is the gesture */
    go(i);
    label();
    closeBtn.focus({ preventScroll: true });
    cancelAnimationFrame(barRaf);
    barRaf = requestAnimationFrame(bar);
  }

  function closeView() {
    if (!viewOn) return;
    viewOn = false;
    cancelAnimationFrame(barRaf);
    vid.pause();
    view.classList.remove('is-on');
    document.documentElement.classList.remove('reelpop-lock');
    hideT = setTimeout(function () {
      view.hidden = true;
      vid.removeAttribute('src'); vid.load();            /* let go of the file */
    }, still() ? 0 : 260);
    if (opener && document.contains(opener) && opener.getClientRects().length) opener.focus({ preventScroll: true });
    opener = null;
  }

  /* getClientRects, not offsetParent: offsetParent is null for everything inside position fixed */
  function trap(e) {
    var f = [].slice.call(view.querySelectorAll('button,a[href]')).filter(function (el) { return el.getClientRects().length > 0; });
    if (!f.length) return;
    var a = document.activeElement, inside = view.contains(a);
    if (e.shiftKey && (a === f[0] || !inside)) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && (a === f[f.length - 1] || !inside)) { e.preventDefault(); f[0].focus(); }
  }

  document.addEventListener('keydown', function (e) {
    if (!viewOn) return;
    if (e.key === 'Escape') { e.preventDefault(); closeView(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    else if (e.key === 'Tab') trap(e);
  });

  /* a handle for checking the build from the console, nothing on the site calls it */
  window.MOGPOP = {
    open: function (i) { openView(i || 0, cards[i || 0] || null); },
    close: closeView,
    get state() {
      return { shown: st.shown, ready: st.ready, arrived: st.arrived, aside: st.aside, hidden: st.hidden,
        viewer: viewOn ? cur : -1, muted: vid ? vid.muted : null, touch: touch, still: still() };
    }
  };

  /* ---------- start ---------- */

  /* It does not arrive with empty cards or with the hashtag in a fallback face: the stills and the
     hand are in before the first entrance, or three seconds have passed. */
  function prime() {
    var left = N + 1, done = false;
    function one() { if (--left <= 0) all(); }
    function all() { if (done) return; done = true; st.ready = true; measure(); }
    REELS.forEach(function (r) { var im = new Image(); im.onload = im.onerror = one; im.src = r.thumb || r.poster; });
    if (document.fonts && document.fonts.load) document.fonts.load("400 40px 'Covered By Your Grace'").then(one, one); else one();
    setTimeout(all, 3000);
  }

  function boot() {
    /* the hand is linked by the reel section only (its link in theme.liquid sits behind
       films_live). On a page without that section the widget brings its own. */
    if (!document.querySelector('link[href*="Covered+By+Your+Grace"]')) {
      document.head.appendChild(h('link', '', { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Covered+By+Your+Grace&display=swap' }));
    }
    build();
    observe();
    prime();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', schedule);
    measure();
  }
  if (document.body) boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
